module.exports = __webpack_public_path__ + "img/services4.jpg?94d4848872f407c24948d28487aaddf2";